export const MANAGE_ASSETS_DEEPLINK_QUERY_PARAMS = {
  APP_ID: 'app_id',
};

export const MANAGE_ASSETS_DEEPLINK_SESSION_KEYS = {
  RETURN_URL: 'manage_assets_deeplink.returnUrl',
};

export const MANAGE_ASSETS_ACCOUNTS_QUERY_PARAM = 'manage';

export const MANAGE_ASSETS_OPEN = 'open';

export const isManageAssetsRequested = (search) =>
  new URLSearchParams(search).get(MANAGE_ASSETS_ACCOUNTS_QUERY_PARAM) === MANAGE_ASSETS_OPEN;
